"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Tue Mar 17 2020
 */

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author Tomas Leity
 */


var ForecastSimulationSaveResultDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(ForecastSimulationSaveResultDTO, _DomainObject_1$Domai);

  /**
   * @param conflicts
   * @param validationResult
   */
  function ForecastSimulationSaveResultDTO(conflicts, validationResult) {
    var _this;

    _classCallCheck(this, ForecastSimulationSaveResultDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ForecastSimulationSaveResultDTO).call(this));
    _this.conflicts = conflicts;
    _this.validationResult = validationResult;
    return _this;
  }

  return ForecastSimulationSaveResultDTO;
}(DomainObject_1.DomainObject);

exports.ForecastSimulationSaveResultDTO = ForecastSimulationSaveResultDTO;